import { render } from "./Usage.vue?vue&type=template&id=44ef3ca9&scoped=true&ts=true"
import script from "./Usage.vue?vue&type=script&lang=ts"
export * from "./Usage.vue?vue&type=script&lang=ts"

import "./Usage.vue?vue&type=style&index=0&id=44ef3ca9&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ef3ca9"]])

export default __exports__